
import Config from "../../config/Config";
import axios from "axios";

const baseUrlDev = Config.BaseUrlDev;
const bearer = () => {
  return localStorage.getItem("token_redux").replaceAll('"', "");
};
export const getProfile = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}katalis/user`, {
        Authorization: `Bearer ${bearer()}`,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getConfigSelfRegister = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${baseUrlDev}api_default/config/self_register/get_config_self_register`,
        {
          headers: {
            Authorization: `Bearer ${localStorage
              .getItem("token_redux")
              .replaceAll('"', "")}`,
          },
        },
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateUser = (data) => {
  let url = baseUrlDev + "katalis/user";
  return new Promise((resolve, reject) => {
    axios
      .put(url, data, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
};

export const updatePassword = (data) => {
  let url = baseUrlDev + "katalis/sso/credential/change";
  return new Promise((resolve, reject) => {
    axios
      .put(url, data, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
};

export const forgotPassword = (data) => {
  let url = baseUrlDev + "katalis/sso/credential/forget";
  return new Promise((resolve, reject) => {
    axios
      .put(url, data, {})
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
};

export const checkOTP = (data) => {
  let url = baseUrlDev + "katalis/sso/credential/forget";
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {})
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
};
export const uploadPhoto = (image) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", image);
    axios
      .post(`${baseUrlDev}main_a/image/upload_image`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const changeSecurityCode = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`${baseUrlDev}mob_user/security_code`, data, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const sendOtp = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${baseUrlDev}mob_user/security_code/forgot_security_code?email=${data}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage
              .getItem("token_redux")
              .replaceAll('"', "")}`,
          },
        },
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const forgetSecurityCode = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .put(
        `${baseUrlDev}mob_user/security_code/update_security_code_after_forgot`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage
              .getItem("token_redux")
              .replaceAll('"', "")}`,
          },
        },
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const createPassword = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`${baseUrlDev}katalis/sso/credential/mobile/create`, data, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        // console.log("changepassword");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const changePassword = (oldPassword, newPassword) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${baseUrlDev}api_default/auth/user_change_password?oldPassword=${oldPassword}&newPassword=${newPassword}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage
              .getItem("token_redux")
              .replaceAll('"', "")}`,
          },
        },
      )
      .then((res) => {
        // console.log("changepassword");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getProvince = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}api_default/wilayah/getAllProvinces`, {})
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getRegency = (idProvince) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}api_default/wilayah/getRegencies/${idProvince}`, {})
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getDistrict = (idRegency) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}api_default/wilayah/getDistricts/${idRegency}`, {})
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const requestOtp = (body) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrlDev}katalis/sso/credential/otp/request`, body)
      .then((res) => {
        // console.log("changepassword");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const mergeAccount = (body, userId) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrlDev}katalis/sso/credential/merge/${userId}`, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token_redux").replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const mergeWithOtp = (otp) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrlDev}katalis/sso/user/merge?otp=${otp}`, null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token_redux").replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const changeUser = (userId, companyId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${baseUrlDev}katalis/user/credential/change/${companyId}?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token_redux").replaceAll('"', "")}`,
          },
        },
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
